module.exports = __webpack_public_path__ + "img/21.10.pH.7c8da7a4.png";